var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIconmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.403 10.889l-2.258-.258a1.77 1.77 0 00-1.457.507l-1.636 1.635a13.374 13.374 0 01-5.858-5.857L4.84 5.27a1.77 1.77 0 00.506-1.458l-.257-2.24A1.779 1.779 0 003.318 0H1.782C.777 0-.059.836.003 1.84c.471 7.591 6.542 13.653 14.125 14.124 1.004.063 1.84-.773 1.84-1.777v-1.538a1.762 1.762 0 00-1.565-1.76z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconmin);
export default __webpack_public_path__ + "static/media/PhoneIcon.min.2b03f0c2ceb1bcf4169c8e72744f7b93.svg";
export { ForwardRef as ReactComponent };